import { render, staticRenderFns } from "./ModalAddCustomer.vue?vue&type=template&id=0a29c6bc&scoped=true&"
import script from "./ModalAddCustomer.vue?vue&type=script&lang=js&"
export * from "./ModalAddCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddCustomer.vue?vue&type=style&index=0&id=0a29c6bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a29c6bc",
  null
  
)

export default component.exports